import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-363f90c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "range-input" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Range input", -1))
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Multiply ")
const _hoisted_5 = {
  class: "checkbox-inputs",
  "data-test": "checkbox-container"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Checkboxes", -1))
const _hoisted_7 = ["data-test"]
const _hoisted_8 = { class: "checkbox-label" }
const _hoisted_9 = ["for"]
const _hoisted_10 = ["id", "value", "data-test", "onInput"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))

import { ref } from 'vue';

interface MealOption {
  name: string,
  selected: boolean | string
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const meal = ref([
  {
    name: "Pizza",
    selected: false,
  },
  {
    name: "Spaghetti",
    selected: false,
  },
  {
    name: "Caesar's salad",
    selected: false,
  },
]);

const rating=ref(0);

const changeRating = (event: any): number => {
  return rating.value = event.target.value;
};

const toggleCheckbox = (item: MealOption): boolean | string => {
  if(typeof(item.selected)==='boolean') {
    return item.selected = !item.selected;
  } else {
    return item.selected = item.selected.split("").reverse().join("");
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("input", {
        type: "range",
        min: "0",
        max: "10",
        value: rating.value,
        onInput: changeRating,
        "data-test": "range-input"
      }, null, 40, _hoisted_3),
      _createElementVNode("div", null, [
        _hoisted_4,
        _createElementVNode("strong", null, _toDisplayString(rating.value), 1),
        _createTextVNode(" with 10 = " + _toDisplayString(rating.value*10), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(meal.value, (selection, index) => {
        return (_openBlock(), _createElementBlock("p", {
          key: selection.name+index,
          "data-test": `checkbox-wrapper-${selection.name}`
        }, [
          _createElementVNode("span", _hoisted_8, [
            _createElementVNode("label", {
              for: selection.name,
              class: "checkbox-input-container"
            }, [
              _createElementVNode("span", null, _toDisplayString(selection.name) + ": ", 1),
              _createElementVNode("input", {
                type: "checkbox",
                id: selection.name,
                value: selection.selected,
                "data-test": `checkbox-${selection.name}`,
                onInput: ($event: any) => (toggleCheckbox(selection))
              }, null, 40, _hoisted_10),
              _hoisted_11
            ], 8, _hoisted_9),
            _createElementVNode("span", null, _toDisplayString(selection.selected), 1)
          ])
        ], 8, _hoisted_7))
      }), 128))
    ])
  ]))
}
}

})